import { getData, postData, putData, deleteData, extractFile, errorHandler } from './index';
import { PROJECT_ERROR, 
  FETCH_PROJECTS, 
  FETCH_PROJECT, 
  FETCH_PROJECT_LIST, 
  CREATE_PROJECT, 
  UPDATE_PROJECT, 
  DELETE_PROJECT, 
  UPDATE_PROJECT_PICTURE, 
  EXPORT_PROJECTS_LIST,
  LOADING } from './types';

//= ===============================
// Project actions
//= ===============================

export function fetchProjects() {
    return async (dispatch) => {
      const url = '/project';   
      await dispatch({
        type: LOADING,
      });
      getData(FETCH_PROJECTS, PROJECT_ERROR, true, url, dispatch);
    } 
}

export function fetchProject(documentId) {
  return async (dispatch) => {
    const url = '/project/' +documentId;  
    await dispatch({
      type: LOADING,
    });
    getData(FETCH_PROJECT, PROJECT_ERROR, true, url, dispatch);
  } 
}

export function getAutocompleteList(documentId) {
    const url = `/project/autocompleteList/${documentId}`
  return dispatch => getData(FETCH_PROJECT_LIST, PROJECT_ERROR, true, url, dispatch);
}

export function createProject() {
  let editor = JSON.parse(localStorage.getItem("user"));
  const data = {};
  data.consultantEditor = {
    firstName : editor.firstName,
    LastName : editor.lastName,
    _id : editor._id
  }

  const url = '/project';
  return dispatch => postData(CREATE_PROJECT, PROJECT_ERROR, true, url, dispatch, data);
}

export function createProjectForConsultant(consultant) {
  let editor = consultant
  const data = {};
  data.consultantEditor = {
    firstName : editor.firstName,
    LastName : editor.lastName,
    _id : editor._id
  }
  const url = '/project';
  return dispatch => postData(CREATE_PROJECT, PROJECT_ERROR, true, url, dispatch, data);
}

export function updateProject(document, documentId) {
    const data = { document };
  
    const url = '/project/' +documentId
  return dispatch => putData(UPDATE_PROJECT, PROJECT_ERROR, true, url, dispatch, data);
}

export function updateFieldProject(document, documentId){
    const data = { document };

    const url = '/project/updatefield/' +documentId
  return dispatch => putData(UPDATE_PROJECT, PROJECT_ERROR, true, url, dispatch, data);
}

export function addFieldProject(document, parent, documentId){
    const data = { document };
  data.parent = parent
    const url = '/project/addfield/' +documentId
  return dispatch => putData(UPDATE_PROJECT, PROJECT_ERROR, true, url, dispatch, data);
}

export function removeFieldProject(i, parent, documentId){
  const data = {
    parent : parent,
    index : i
  };
    const url = '/project/removefield/' +documentId
  return dispatch => putData(UPDATE_PROJECT, PROJECT_ERROR, true, url, dispatch, data);
}

export function deleteProject(documentId) {
    const url = '/project/' + documentId;
  return dispatch => deleteData(DELETE_PROJECT, PROJECT_ERROR, true, url, dispatch);
}


export function validate(documentId){
  
  const data = { };
  const url = '/project/validation/validate/' + documentId
  return dispatch => putData(UPDATE_PROJECT, PROJECT_ERROR, true, url, dispatch, data);
}

export function submit(documentId){
  const data = { };
  const url = '/project/validation/submit/' + documentId
  return dispatch => putData(UPDATE_PROJECT, PROJECT_ERROR, true, url, dispatch, data);
}

export function draft(documentId){
  const data = { };
  const url = '/project/validation/draft/' + documentId
  return dispatch => putData(UPDATE_PROJECT, PROJECT_ERROR, true, url, dispatch, data);
}

export function reject(documentId,rejectReason){
  const data = { rejectReason : rejectReason};
  const url = '/project/validation/reject/' + documentId
  return dispatch => putData(UPDATE_PROJECT, PROJECT_ERROR, true, url, dispatch, data);
}

export function extractProject(documentId) {
  return async (dispatch) => {
    const url = '/project/extract/' +documentId; 
    await dispatch({
      type: LOADING,
    });
    getData(FETCH_PROJECT, PROJECT_ERROR, true, url, dispatch);
  }
}

export function uploadPicture(file, documentId) {
  let data = new FormData()
  data.append('file', file)
    const url = '/project/picture/' +documentId;
  return dispatch => putData(UPDATE_PROJECT_PICTURE, PROJECT_ERROR, true, url, dispatch, data);
}

export function getExportProjectsList(filter) {
  return async (dispatch) => {
    const url = `/project/export?filter=${encodeURIComponent(JSON.stringify(filter))}`;
    await dispatch({
      type: LOADING,
    });
    extractFile(EXPORT_PROJECTS_LIST, PROJECT_ERROR, true, url, dispatch);
  }
}

export function resetError(){
  return dispatch => errorHandler(dispatch,{data:{error:""}},PROJECT_ERROR);
}